import React, { Component} from 'react'
import Store from '../store/ProductionTableStore'
import TableHeader from '../partials/table/TableHeader'
import TableBody from '../partials/table/TableBody'
import TableFooter from '../partials/table/TableFooter'
import Popup from '../partials/popup'
import ChangeOrderDatePopup from '../partials/ChangeOrderDatePopup'
import { observer } from 'mobx-react'

@observer
class ListOrders extends Component {
    render() {  
        let tables = []        
        let days = Object.keys(Store.ordersByDate)
        
        if (days.length > 0) {
            days.forEach((day, index) => {
                let header = null
                let footer = null
                let orders = []
                
                if (day !== 'late_orders' ) {                                            
                    const currentDay = Store.ordersByDate[day]

                    if (currentDay.orders.length > 0) {                        
                        header = <TableHeader
                            title={ currentDay.day }
                            subTitle={ currentDay.date }
                            day={ currentDay }
                        />

                        currentDay.orders.forEach((order, key) => {
                            orders.push(
                                <TableBody
                                    key={ `table-body-${ index + key + currentDay.date }` }
                                    date={ day }
                                    order={ order }
                                    orderPosition={ key }
                                />
                            )                        
                        })

                        footer = <TableFooter day={ currentDay } />

                        tables.push(
                            <div className="table" key={ `table-${ index }` }>
                                { header }
                                
                                <div className={ `table__wrap ${ currentDay.openDayBar ? 'table__wrap--open' : '' }` }>
                                    { orders }
                                </div>

                                { footer }

                                <Popup
                                    type="default"
                                    show={ Store.popup.show }
                                />
                                <ChangeOrderDatePopup
                                    show={ Store.popupChangeDate.show }
                                />
                            </div>
                        )
                    }
                }
            })
        } else {                
            tables.push(
                <div className="production-noOrdersFound" key={ 'currentOrders-0' }>
                    <h3 className="production-noOrdersFound__title">Inga ordrar hittades</h3>
                </div>
            )
        }

        return tables
    }
}

export default ListOrders
